import React from "react";
import PropTypes from "prop-types";
import { Button } from "primereact/button";
import agent from "../../../../agent";

/**
 * Дата со временем в формате, который ждёт бэкенд для фильтра подписания АВР.
 * У соседних вкладок фильтр по дате без времени, здесь — с временем, поэтому формат свой.
 */
const ensureDateTimeString = (val) => {
    if (!val) return undefined;
    try {
        const d = new Date(val);
        if (Number.isNaN(d.getTime())) return undefined;
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    } catch (e) {
        return undefined;
    }
};

const getFilenameFromContentDisposition = (cd, fallback = "report.xlsx") => {
    try {
        if (!cd || typeof cd !== "string") return fallback;
        let m = cd.match(/filename\*=(?:UTF-8'')?([^;\s]+)/i);
        if (m && m[1]) {
            const raw = m[1].trim().replace(/^"|"$/g, "");
            try {
                return decodeURIComponent(raw);
            } catch (_) {
                return raw;
            }
        }
        m = cd.match(/filename="?([^";]+)"?/i);
        if (m && m[1]) return m[1];
        return fallback;
    } catch (_) {
        return fallback;
    }
};

const AvrCheckActionBar = ({ filterParam }) => {
    const handleExport = async () => {
        try {
            const params = {
                slqNum: filterParam?.slqNum || undefined,
                checkNumber: filterParam?.checkNumber || undefined,
                fio: filterParam?.fio || undefined,
                iin: filterParam?.iin || undefined,
                signedFrom: ensureDateTimeString(filterParam?.signedFrom) || undefined,
                signedTo: ensureDateTimeString(filterParam?.signedTo) || undefined,
                status: filterParam?.status || undefined,
            };
            const res = await agent.Payments.getAvrCheckReportFile(params);
            const cd =
                (res && (res.header?.["content-disposition"] || res.headers?.["content-disposition"])) || "";
            const filename = getFilenameFromContentDisposition(cd, "avr_check_report.xlsx");
            const blob =
                res?.body instanceof Blob
                    ? res.body
                    : new Blob([res?.text || ""], {
                          type:
                              res?.type ||
                              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            const msg = agent.handleError(err);
            alert(msg);
        }
    };

    return (
        <div className="p-d-flex p-jc-end p-mb-3">
            <Button label="Выгрузить отчет" icon="pi pi-download" onClick={handleExport} />
        </div>
    );
};

AvrCheckActionBar.propTypes = {
    filterParam: PropTypes.object,
};

export default AvrCheckActionBar;
